import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#4A2C40] text-[#FDFBF7]/60 py-12 text-center text-sm" data-id="element-1">
        <div className="max-w-7xl mx-auto px-4" data-id="element-2">
          <p data-id="element-3">
            &copy; {new Date().getFullYear()} The Luteal Survival Kit. All
            rights reserved.
          </p>
          <p className="mt-2" data-id="element-4">Not medical advice. Listen to your body.</p>
          <div className="mt-4 flex items-center justify-center gap-6" data-id="element-5">
            <button onClick={() => setActiveModal('privacy')} className="text-[#FDFBF7]/50 hover:text-[#FDFBF7] transition-colors underline underline-offset-2" data-id="element-6">
              Privacy Policy
            </button>
            <span className="text-[#FDFBF7]/20" data-id="element-7">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-[#FDFBF7]/50 hover:text-[#FDFBF7] transition-colors underline underline-offset-2" data-id="element-8">
              Terms of Service
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Privacy Policy" data-id="element-9">
        <p className="font-semibold text-[#4A2C40]" data-id="element-10">
          Last updated: February 2026
        </p>

        <h3 className="font-serif font-bold text-[#4A2C40] text-base mt-6" data-id="element-11">
          What We Collect
        </h3>
        <p data-id="element-12">
          When you purchase The Luteal Survival Kit, we collect only the
          information needed to process your order: your email address and
          payment details. Payment is handled securely by our third-party
          payment processor — we never store your card information.
        </p>

        <h3 className="font-serif font-bold text-[#4A2C40] text-base mt-6" data-id="element-13">
          How We Use Your Information
        </h3>
        <p data-id="element-14">
          Your email is used solely to deliver your purchase and send any
          product updates you've opted into. We do not sell, rent, or share your
          personal information with third parties for marketing purposes.
        </p>

        <h3 className="font-serif font-bold text-[#4A2C40] text-base mt-6" data-id="element-15">
          Cookies
        </h3>
        <p data-id="element-16">
          Our site may use basic analytics cookies to understand how visitors
          interact with the page. These do not collect personally identifiable
          information.
        </p>

        <h3 className="font-serif font-bold text-[#4A2C40] text-base mt-6" data-id="element-17">
          Your Rights
        </h3>
        <p data-id="element-18">
          You may request access to, correction of, or deletion of your personal
          data at any time by reaching out to us. We will respond within 30
          days.
        </p>

        <h3 className="font-serif font-bold text-[#4A2C40] text-base mt-6" data-id="element-19">
          Changes
        </h3>
        <p data-id="element-20">
          We may update this policy from time to time. Any changes will be
          reflected on this page with an updated date.
        </p>
      </LegalModal>

      {/* Terms of Service Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Terms of Service" data-id="element-21">
        <p className="font-semibold text-[#4A2C40]" data-id="element-22">
          Last updated: February 2026
        </p>

        <h3 className="font-serif font-bold text-[#4A2C40] text-base mt-6" data-id="element-23">
          Product
        </h3>
        <p data-id="element-24">
          The Luteal Survival Kit is a digital PDF product designed for
          educational and informational purposes. It is not a substitute for
          professional medical advice, diagnosis, or treatment. Always consult a
          qualified healthcare provider with questions about your health.
        </p>

        <h3 className="font-serif font-bold text-[#4A2C40] text-base mt-6" data-id="element-25">
          Digital Delivery
        </h3>
        <p data-id="element-26">
          Upon purchase, you will receive instant access to download the PDF.
          Due to the digital nature of this product, all sales are final. If you
          experience any issues with your download, we're happy to help.
        </p>

        <h3 className="font-serif font-bold text-[#4A2C40] text-base mt-6" data-id="element-27">
          Intellectual Property
        </h3>
        <p data-id="element-28">
          All content within The Luteal Survival Kit — including text,
          templates, checklists, and design — is protected by copyright. You may
          use the materials for personal use only. Redistribution, resale, or
          reproduction without permission is prohibited.
        </p>

        <h3 className="font-serif font-bold text-[#4A2C40] text-base mt-6" data-id="element-29">
          Disclaimer
        </h3>
        <p data-id="element-30">
          Results vary. The strategies in this kit are based on general wellness
          principles and are not guaranteed to produce specific outcomes. By
          purchasing, you acknowledge that you are responsible for how you apply
          the information provided.
        </p>

        <h3 className="font-serif font-bold text-[#4A2C40] text-base mt-6" data-id="element-31">
          Changes
        </h3>
        <p data-id="element-32">
          We reserve the right to update these terms at any time. Continued use
          of the product constitutes acceptance of any changes.
        </p>
      </LegalModal>
    </>;
}